import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import ScrollNav from "./ScrollNav";
import { useEffect } from "react";

const Layout = () => {
  const location = useLocation();

  useEffect(() => {
    const scrollPage = () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    };

    // Small delay to allow page render first
    const timer = setTimeout(scrollPage, 80);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  // Hide footer only on /menu
  const hideFooter = location.pathname.startsWith("/menu");

  return (
    <div className="bg-darkbg text-white min-h-screen">
      <Navbar />

      <ScrollNav color="text-navy" />

      <main>
        <Outlet />
      </main>

      {!hideFooter && <Footer />}
    </div>
  );
};

export default Layout;
